import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-no-records',
  templateUrl: './noRecords.html'

})

export class NoRecordsComponent {

}
